module.exports = __webpack_public_path__ + "img/VI.9526c3fd.svg";